import { render, staticRenderFns } from "./AgentBranch.vue?vue&type=template&id=27036f81"
import script from "./AgentBranch.vue?vue&type=script&lang=js"
export * from "./AgentBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports